import { CorporatePass } from '@api';
import classnames from 'classnames';
import React from 'react';
import { Field } from 'redux-form';
import { TextField } from 'src/js/components/form-new/TextField';

interface Props {
  onSubmitPass: (code: string) => void;
  corporatePass?: CorporatePass;
  corporatePassError?: string;
  onUnmount?: () => void;
  fetching?: boolean;
  passInputValue?: string;
}

class CorporatePassComp extends React.Component<Props, any> {
  componentWillUnmount() {
    // recalculate amount after reset corporate pass
    const {corporatePass, onUnmount} = this.props;
    if (corporatePass.id) {
      onUnmount();
    }
  }

  handleClick() {
    const {passInputValue} = this.props;
    const {onSubmitPass} = this.props;
    onSubmitPass(passInputValue);
  }

  render() {
    const {corporatePass, corporatePassError, fetching} = this.props;

    const passField = () => (
      <div className="pass-input">
        <Field
          component={TextField}
          maxLength={40}
          className="input-fixed"
          autoComplete="off"
          name="code"
          label="Code"
          type="text"
          required={true}
          forwardRef
        />
        <div className="button" id="addCorporatePass" onClick={() => this.handleClick()}>Submit</div>
      </div>
    );

    const referenceField = () => (
      <div className="pass-input">
        <Field
          component={TextField}
          maxLength={40}
          className="input-fixed "
          autoComplete="off"
          name="reference"
          label="Your Reference (Optional)"
          type="text"
        />
      </div>
    );

    return (
      <div id="corporate-pass" className={classnames('single-tab active', {fetching})}>
        <fieldset className="field-wrapper corporate-pass-wrapper">
          <p className="info-content">
            Enter a Corporate Pass code below to complete this transaction without any payment at this time.
            Corporate Pass is available to pre-approved corporate clients only.
          </p>

          {!corporatePass.id &&
            passField()
          }

          {corporatePass.id &&
            referenceField()
          }

          {corporatePass.message &&
          <div className="message">
            {corporatePass.message}
          </div>
          }

          {corporatePassError &&
          <div className="validation">
            {corporatePassError}
          </div>
          }
        </fieldset>
      </div>
    );
  }
}

export default CorporatePassComp;

